import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import http from "../http";

const initialState = {
    data: null,
    splash_open: false,
    loading: false,
}

export const fetchSplash = createAsyncThunk('splash', async () => {
    const response = await http.post("/v1/splash")
    return response.data
})

const slice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        //开屏状态
        SetSplashOpen(state, action) {
            state.splash_open = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchSplash.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSplash.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.isSuccess == 1) {
                    state.data = action.payload.item;
                }
                else {
                    state.data = null;
                }

            })
            .addCase(fetchSplash.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
})

export const { SetSplashOpen } = slice.actions

export default slice.reducer